export default __webpack_public_path__ + "static/KIDSANDUS_RGB_BLACK-dc13e2655cf1ceca7c7bd1f6e5c097d5.png";